import { Link } from "react-router-dom";
import { sanitizeHTML } from "../../helper/SanitizeHTML";
const Breadcrumb = ({ crumbs }) => {
  return (
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <ol id="breadcrumbs" className="breadcrumbs breadcrumb">
          {crumbs.map((crumb, i) =>
            crumb?.path ? (
              <li key={i}>
                <Link to={crumb.path}>{crumb.title}</Link>
              </li>
            ) : (
              // if crumb is {} it will show only "/" modified for subject-detail page header
              <li key={i}>
                {/* WEB-331 - fixing the breadcrumbs title issue using dangerouslySetInnerHTML  */}
                <span className="bread-current bread-8" dangerouslySetInnerHTML={sanitizeHTML(crumb?.title)} />
              </li>
            )
          )}
        </ol>
      </div>
    </div>
  );
};

export default Breadcrumb;
